import {runInAction} from "mobx";

import {isJson} from "../components/admin/spinup/utilities";
import {use, useEffect} from "react";

export default function useFinalizeBlock(blockObj, initialBlockPromise) {
    const asyncData = initialBlockPromise ? use(initialBlockPromise) : null;
    useEffect( () => {
        if (asyncData) {
            runInAction(() => {
                blockObj.setAttributes({
                    ...asyncData,
                    loadAsync: blockObj.loadAsync,
                    asyncLoaded: true,
                });
            })
        }
    }, []);
    // this is here so in ToolDrawerGrid -> ExampleBlock we update the block from loading to whatever when we get a new blockObj
    if (!blockObj.loadAsync && isJson(blockObj.htmlOutput)) {
        runInAction(() => {
            let newSettings = JSON.parse(blockObj.htmlOutput);
            const newBlockObj = newSettings?.blockObj;
            // for some reason the youtube/video blocks send blockObj as htmlOutput instead of filling the htmlOutput.
            if (newBlockObj) newSettings = {...newSettings, ...newBlockObj};
            if (blockObj.setAttributes) {
                blockObj.setAttributes({...newSettings});
            }
        })
    }
}
